export default __webpack_public_path__ + "static/media/PAFI_Calon Anggota Direksi dan Dewan Komisaris 2024-2029.d3aefdea.pdf";